import { useEffect, useState } from 'react';
import { FieldConfig } from '../../../components/CustomFormsComponents/CustomField';

const useRestartAvisoObraFieldsConfig = ({
    t,
    formData,
    handleBlurValidation,
    selectedObra
}: any) => {
    const [fieldsConfig, setFieldsConfig] = useState<FieldConfig[]>([]);

    useEffect(() => {
        const fechaFinObra = selectedObra?.fechaFin ? new Date(selectedObra.fechaFin) : null;

        const fieldsConfig: FieldConfig[] = [
            {
                type: 'date-mui',
                label: t('avisoObraForms.restart.inputs.restartDate') as string,
                name: 'restartDate',
                required: true,
                value: formData.restartDate,
                disabled: false,
                helperText: fechaFinObra
                    ? `Debe ser posterior al fin original (${fechaFinObra.toLocaleDateString(
                          'es-AR'
                      )})`
                    : t('avisoObraForms.restart.inputs.restartDate'),
                onBlurValidation: (name: string, value: any) => {
                    if (!value) {
                        handleBlurValidation(name, true, t('avisoObraForms.validation.required'));
                    } else {
                        handleBlurValidation(name, false, '');
                    }
                },
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }],
                minDate: fechaFinObra ? fechaFinObra.toISOString() : undefined
            },
            {
                type: 'date-mui',
                label: t('avisoObraForms.restart.inputs.endDate') as string,
                name: 'endDate',
                required: true,
                value: formData.endDate,
                disabled: false,
                helperText: t('avisoObraForms.restart.inputs.endDate'),
                onBlurValidation: (name: string, value: any) => {
                    if (!value) {
                        handleBlurValidation(name, true, t('avisoObraForms.validation.required'));
                    } else {
                        handleBlurValidation(name, false, '');
                    }
                },
                gridSpace: { xs: 12 },
                validations: [{ name: 'required' }],
                minDate:
                    formData.restartDate || (fechaFinObra ? fechaFinObra.toISOString() : undefined)
            }
        ];

        setFieldsConfig(fieldsConfig);
    }, [t, selectedObra]);

    return {
        fieldsConfig
    };
};

export default useRestartAvisoObraFieldsConfig;
